import { render, staticRenderFns } from "./HandleItem.vue?vue&type=template&id=7f86ad36"
import script from "./HandleItem.vue?vue&type=script&lang=js"
export * from "./HandleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports